import styled, { css } from 'styled-components';

export const NegativeSignWrapper = styled.div`
  ${({ theme }) => css`
    margin-left: -${theme.spacing.km3};
  `}
`;
